import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section, SectionTitle } from '../Section';
import { CTAButton } from '../CTAButton';
export function GuaranteeSection() {
  return <Section tone="wine" className="text-center" data-id="element-49" data-mp="1kblyhj10ubly">
      <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full border-2 border-gold" data-id="element-50" data-mp="1ka16o163d6rs">
        <ShieldCheckIcon aria-hidden="true" strokeWidth={1.25} className="h-12 w-12 text-gold" data-id="element-51" data-mp="1faoldkuvc7rb" />
      </div>
      <SectionTitle className="mt-7" data-id="element-52" data-mp="1abbmu2umxc8w">Pruébala 7 días.</SectionTitle>
      <p className="mx-auto mt-5 max-w-[480px] text-[17px] leading-relaxed text-ivory/90" data-id="element-53" data-mp="15dtk4u77nt9c">
        Si sientes que no es para ti, pides tu reembolso desde Hotmart dentro de los primeros 7 días.
      </p>
      <div className="mt-8" data-id="element-54" data-mp="wfhnobjny18z">
        <CTAButton data-id="element-55" data-mp="wg9mdv8k4f3h" />
      </div>
    </Section>;
}